import Header from '../Header/Header'
import Spinner from '../Spinner/Spinner'
import classes from './DragAndDropFile.module.scss'

const UploadingFile = () =>
  <div
    className={classes.DragAndDropFile + ' ' + classes.dropped}
  >
    <Spinner
      singleColor='purple'
      size={80}
    />
    <Header
      hasNoTopMargin
      rank={4}
    >
      Uploading file...
    </Header>
  </div>

export default UploadingFile
